export default "/DDP.glb";